import TextWithImageItem, { TextWithImageItemProps, IMAGE_POSITION } from './TextWithImageItem'

export default TextWithImageItem

export { TextWithImageItemProps, TextWithImageItem, IMAGE_POSITION }
